import axios from "axios";
import config from "../../config/config";
import { attachSessionInterceptors } from "./httpClient";

const api = attachSessionInterceptors(
  axios.create({
    baseURL: config.BASE_URL,
    withCredentials: true,
  }),
);

export async function fetchMyNavigation(roleSlug) {
  const params = roleSlug ? { roleSlug } : undefined;
  const response = await api.get("/navigation/me", { params });
  if (!response.data?.success) {
    throw new Error(response.data?.message || "Failed to load navigation");
  }
  return response.data.data;
}
